import { render, staticRenderFns } from "./FeedbacksDetail.vue?vue&type=template&id=0922e782&scoped=true&"
import script from "./FeedbacksDetail.vue?vue&type=script&lang=js&"
export * from "./FeedbacksDetail.vue?vue&type=script&lang=js&"
import style0 from "./FeedbacksDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FeedbacksDetail.vue?vue&type=style&index=1&id=0922e782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0922e782",
  null
  
)

export default component.exports